import React from 'react';
import { IplpTemplate } from '../../../../../graphql/graphql';
import IPLPTemplateListFilter from './IPLPTemplateListFilter';
import IPLPTemplateListControls from './IPLPTemplateListControls';
import ScrollContainer from '../../../../Base/Components/ScrollContainer';
import FlatList from '../../../../Base/Components/FlatList';
import IPLPTemplateListItem from './IPLPTemplateListItem';
import { useIPLPTemplate } from '../../../Hooks/useIPLPTemplate';
import useFlatData from '../../../../Base/Hooks/useFlatData';
import { useAppContext } from '../../../../../Services/AppContext';
// @ts-ignore
import styles from './IPLPTemplateList.module.scss';

interface Props {
	onItemSelect: (item: IplpTemplate) => void;
}

const wrapperId = 'IPLPTemplateListWrapper';

const IPLPTemplateList: React.FC<Props> = ({ onItemSelect }) => {
	const { workplaceId } = useAppContext();
	const { getIPLPTemplates, getNextPage, data, isLoading, page, setPage } =
		useIPLPTemplate();

	const { flatData, hasMoreData, loadData, setFilter } = useFlatData(
		getIPLPTemplates,
		{
			data: data?.iplpTemplates?.data,
			totalPages: data?.iplpTemplates?.meta?.totalPages,
			page: data?.iplpTemplates?.meta?.page,
		},
		page,
		setPage,
		{
			workplaceId,
		},
	);

	const handleReloadList = () => {
		loadData(true);
	};

	return (
		<div className={styles.wrapper}>
			<IPLPTemplateListFilter onFilter={setFilter} />
			<IPLPTemplateListControls onCreateIPLPTemplate={handleReloadList} />
			<ScrollContainer wrapperId={wrapperId} className={styles.content}>
				<FlatList
					onRefresh={loadData}
					onLoadMore={getNextPage}
					data={flatData}
					isLoading={isLoading}
					hasMoreData={hasMoreData}
					scrollableTargetId={wrapperId}
					itemKey={'id'}
					renderItem={item => (
						<IPLPTemplateListItem
							item={item}
							onUpdate={handleReloadList}
							onDelete={handleReloadList}
							onSelect={onItemSelect}
						/>
					)}
				/>
			</ScrollContainer>
		</div>
	);
};

export default IPLPTemplateList;
